import React, {useContext} from "react";
import {WorkstationMetricsContext} from "./context/WorkstationMetricsContext";
import {emptyArrayIfNull} from "../util/Util";
import Row from "@amzn/meridian/row";
import PickStatusViewV2 from "../pickStatus/PickStatusV2";
import Box from "@amzn/meridian/box";
import Column from "@amzn/meridian/column";
import Text from "@amzn/meridian/text";
import {FormattedMessage} from "react-intl";
import StaticMetricView from "../pickStatus/StaticMetricView";
import {getPickStationMetrics} from "../util/DataTransformUtil"
import * as FilterUtil from "../util/FilterUtil";
import {CapabilityContext} from "../global/context/CapabilityContext";
import {PickFilterContext} from "../pickStatus/context/PickFilterContext";


const SummaryTileView = (props) => {
    const {configViewModel} = useContext(CapabilityContext)
    const {viewModelF} = useContext(PickFilterContext)
    const {metricsViewData} = useContext(WorkstationMetricsContext)
    /** Create clone of global metrics list */
    let arMetricsRowList = Array.from(emptyArrayIfNull(metricsViewData.metricsTableData[metricsViewData.granularity]));
    arMetricsRowList = FilterUtil.applyARv2PickStationFilters(arMetricsRowList, viewModelF, configViewModel)

    const stationMetric = getPickStationMetrics(arMetricsRowList);

    const renderTotalStationView = () => {
        return <PickStatusViewV2 data={{
            headerId: "pickStation.total.header",
            defaultHeader: "Total",
            value: stationMetric.totalStation,
            footerId: "pickStation.total.footer",
            defaultFooter: "Stations"
        }} />
    }

    const renderAvgPickTaktView = () => {
        return <PickStatusViewV2 data={{
            headerId: "pickStation.avgPicktakt.header",
            defaultHeader: "Avg. Pick takt",
            value: stationMetric.averagePickTime,
            footerId: "pickStation.avgPicktakt.footer",
            defaultFooter: "sec",
            tooltipText: "Avg time spent picking all picklists for the route.",
            displayTooltip: true
        }} />
    }

    const renderStationPileOnMetric = () => {
        return <StaticMetricView
            data={{
                title: "station.pileon",
                message: "Pile on",
                value: stationMetric.averagePileOn
            }} />
    }

    const renderStationPodGapMetric = () => {
        return <StaticMetricView
            data={{
                title: "station.podgap",
                message: "Pod gaps",
                value: stationMetric.averagePodGap
            }} />
    }

    const renderStationLoggedOutMetric = () => {
        return <StaticMetricView
            data={{
                title: "station.loggedOut",
                message: "Logged Out",
                value: stationMetric.TotalLoggedOutStation
            }} />
    }

    const renderStationMetricsView = () => {
        return <Box type="outline" spacingInset={"medium"}>
            <Column spacingInset={"none"}>
                {/* Title */}
                <Text type="h200">
                    <FormattedMessage id="pickStation.metric.header" defaultMessage="Pick Station" />
                </Text>
                {/* Metrics */}
                <Row width="100%" spacing={"large"}>
                    {renderStationPodGapMetric()}
                    {renderStationPileOnMetric()}
                    {renderStationLoggedOutMetric()}
                </Row>
            </Column>
        </Box>
    }

    return (
        <Row width="100%" maxWidth="100%" wrap={"down"} spacingInset="small none none none" alignmentVertical="stretch" >
            {renderTotalStationView()}
            {renderAvgPickTaktView()}
            {renderStationMetricsView()}
        </Row>
    )
}

export default SummaryTileView;


// WEBPACK FOOTER //
// ./src/components/workstationMetrics/SummaryTileView.js